// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"22be4217","166":"e5a78f04","453":"825386d9","830":"4c02e429"}[chunkId] + ".chunk.js";
};